import "src/global.css";
import "src/locales/i18n";
import Router from "src/routes/sections";
import ThemeProvider from "src/theme";
import { LocalizationProvider } from "src/locales";
import ProgressBar from "src/components/progress-bar";
import { MotionLazy } from "src/components/animate/motion-lazy";
import SnackbarProvider from "src/components/snackbar/snackbar-provider";
import { SettingsDrawer, SettingsProvider } from "src/components/settings";
import { SignedIn, SignedOut, ClerkProvider } from "@clerk/clerk-react";
import DashboardLayout from "src/layouts/dashboard";
import { TokenProvider } from "src/TokenProvider";
import UnAuthRouter from "./routes/sections/unauth";

const PUBLISHABLE_KEY = process.env.REACT_APP_CLERK_PUBLISHABLE_KEY;
if (!PUBLISHABLE_KEY) {
  throw new Error("Missing Publishable Key for Clerk");
}
export default function App() {
  let defaultSettings = {
    themeMode: "light",
    themeDirection: "ltr",
    themeContrast: "default",
    themeLayout: "mini",
    themeColorPresets: "default",
    themeStretch: false,
  };
  return (
    <ClerkProvider
      publishableKey={PUBLISHABLE_KEY}
      allowedRedirectOrigins={["https://harley.workcaremet.com"]}
    >
      <SignedOut>
        <SettingsProvider defaultSettings={defaultSettings}>
          <ThemeProvider>
            <UnAuthRouter />
          </ThemeProvider>
        </SettingsProvider>
      </SignedOut>
      <SignedIn>
        <TokenProvider>
          <LocalizationProvider>
            <SettingsProvider defaultSettings={defaultSettings}>
              <ThemeProvider>
                <MotionLazy>
                  <SnackbarProvider>
                    <SettingsDrawer />
                    <ProgressBar />
                    <DashboardLayout>
                      <Router />
                    </DashboardLayout>
                  </SnackbarProvider>
                </MotionLazy>
              </ThemeProvider>
            </SettingsProvider>
          </LocalizationProvider>
        </TokenProvider>
      </SignedIn>
    </ClerkProvider>
  );
}
